import { z } from 'zod'

export const ADMINSOLOCLASSCODESGET_CONTRACT_VERSION = '1.0.0' as const
export const adminSoloClassCodesGetResponseSchema = z.unknown()
export type AdminSoloClassCodesGetResponse = z.infer<typeof adminSoloClassCodesGetResponseSchema>
